import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Badge, Button, Card, CardBody, Divider, Flex, HStack, Heading, IconButton, SimpleGrid, Skeleton, Stack, Stat, StatLabel, StatNumber, Text, useDisclosure } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { EmptyTable } from 'components/index';
import { FiEdit } from 'react-icons/fi';
import { fetchPickupPoints } from '../../store/actions';

export const PickupPoints = () => {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = React.useRef(null);

    const navigate = useNavigate();

    const { pickup_points, is_loading_pickup_points } = useAppSelector(state => state.pickupPointsReducer);

    const dispatch = useAppDispatch();

    const filterPickupPointsByStatus = (status: boolean) => {
        return pickup_points?.filter((pickup_point: any) => pickup_point?.is_active === status);
    };

    useEffect(() => {
        dispatch(fetchPickupPoints());
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                pt={2}
                pb={10}
            >
                <Stack>
                    <SimpleGrid columns={[1, 1, 3, 3, 3]} spacing={4} pb={3}>
                        <Stat bgColor={'white'} p={4} borderRadius={6} minW={'350px'}>
                            <StatLabel>
                                <Badge>All pickup Points</Badge>
                            </StatLabel>
                            <StatNumber>{pickup_points?.length}</StatNumber>
                        </Stat>
                        <Stat bgColor={'white'} p={4} borderRadius={6}>
                            <StatLabel>
                                <Badge colorScheme={'green'}>Active pickup Points</Badge>
                            </StatLabel>
                            <StatNumber>{filterPickupPointsByStatus(true)?.length}</StatNumber>
                        </Stat>
                        <Stat bgColor={'white'} p={4} borderRadius={6}>
                            <StatLabel>
                                <Badge colorScheme={'red'}>Inactive pickup Points</Badge>
                            </StatLabel>
                            <StatNumber>{filterPickupPointsByStatus(false)?.length}</StatNumber>
                        </Stat>
                    </SimpleGrid>
                    <Stack bg={'white'} p={4} borderRadius={4}>
                        <HStack justifyContent={'space-between'}>
                            <Heading size={'md'}>Pickup points</Heading>
                            <Button colorScheme={'yellow'} size={'sm'} onClick={() => navigate('/pickup-points/add')}>Add Pickup Point</Button>
                        </HStack>
                        <SimpleGrid columns={[1, 2, 2, 2, 2]} spacing={4}>
                            {
                                is_loading_pickup_points ?
                                    <>
                                        <Skeleton height='100px' width={'100%'} />
                                        <Skeleton height='100px' width={'100%'} />
                                    </>
                                    :
                                    pickup_points?.map((pickup_point: any, index: number) => {

                                        // const days = Object.keys(pickup_point?.operating_hours);
                                        // const getDay = days?.filter(day => day === moment().format('dddd'));

                                        return (
                                            < Card key={index} minW={'350px'} >
                                                <CardBody>
                                                    <HStack justifyContent={'space-between'}>
                                                        <Heading size={'md'} textTransform={'capitalize'}>{pickup_point?.name} <Badge colorScheme={pickup_point?.is_active ? 'green' : 'red'}>{pickup_point?.is_active ? 'Active' : 'Inactive'}</Badge></Heading>
                                                        <HStack>
                                                            <IconButton
                                                                colorScheme='yellow'
                                                                aria-label='Edit'
                                                                size={'sm'}
                                                                icon={<FiEdit />}
                                                                as={DefaultLink}
                                                                to='/pickup-points/edit'
                                                                state={{
                                                                    pickup_point
                                                                }}
                                                            />
                                                            {/* <IconButton
                                                        colorScheme='red'
                                                        aria-label='Delete'
                                                        size={'sm'}
                                                        icon={<FiTrash2 />}
                                                        onClick={onOpen}
                                                    /> */}
                                                        </HStack>
                                                    </HStack>
                                                    <Divider my={2} />
                                                    <Text fontWeight={'semibold'} textTransform={'capitalize'} isTruncated>{pickup_point?.address}</Text>
                                                    <Text fontSize={'sm'} color={'gray.500'}>{pickup_point?.email}</Text>
                                                    <Text fontSize={'sm'} color={'gray.500'}>{pickup_point?.phone}</Text>
                                                    {/* <Text fontSize={'sm'} color={'gray.500'}>{moment().format('dddd')}</Text> */}
                                                </CardBody>
                                            </Card>
                                        );
                                    })
                            }
                        </SimpleGrid>
                        {!pickup_points.length && !is_loading_pickup_points && <EmptyTable title='Oops!' description='Your company does not have pickup points.' />}
                    </Stack>
                    <AlertDialog
                        isOpen={isOpen}
                        leastDestructiveRef={cancelRef}
                        onClose={onClose}
                        isCentered
                    >
                        <AlertDialogOverlay>
                            <AlertDialogContent>
                                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                                    Delete Pickup Point
                                </AlertDialogHeader>

                                <AlertDialogBody>
                                    Are you sure? You can&apos;t undo this action afterwards.
                                </AlertDialogBody>

                                <AlertDialogFooter>
                                    <Button ref={cancelRef} onClick={onClose}>
                                        Cancel
                                    </Button>
                                    <Button colorScheme='red' onClick={onClose} ml={3}>
                                        Delete
                                    </Button>
                                </AlertDialogFooter>
                            </AlertDialogContent>
                        </AlertDialogOverlay>
                    </AlertDialog>

                </Stack>
            </Flex>
        </>
    );
};